<script>
import router from "../../router";
import Multiselect from "vue-multiselect";
import moment from "moment";
export default {
  name: "InventoryCounts",
  components: {
    Multiselect
  },
  data() {
    return {
      itemList: [],
      storeList: [],
      supplierList: [],
      categoryList: [],
      selected_items: [],
      filterObj: {
        store_id: "",
        search: "",
        category_id: "",
        supplier_id: ""
      },
      order: {
        id: null,
        store_id: null,
        items: [],
        inventory_count_status: "",
        inventory_count_type: "PARTIAL",
        note: null
      },
      category: {
        id: "",
        name: "",
        flag: ""
      },
      supplier: {
        id: "",
        name: "",
        flag: ""
      },
      note_count: 0
    };
  },
  methods: {
    getItemList(flag, isChangeStore) {
      // console.log('getItemList', flag, isChangeStore)
      if (this.filterObj.store_id) {
        this.order.store_id = this.filterObj.store_id;
      }

      if(isChangeStore){
        this.filterObj.category_id = ''
        this.filterObj.search = ''
        this.filterObj.supplier_id = ''
        this.categoryList = []
        this.itemList = []
        this.selected_items = []
      }

      var filterObjClone =  {...this.filterObj}
      filterObjClone['search'] = ''
      this.$api
        .getAPI({ _action: "/item/purchase_order", _body: filterObjClone })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            if(isChangeStore) {
              this.itemList = res.list;
            }
            if (flag) {
              for (var i = 0; i < res.list.length; i++) {
                this.selected_items.push(res.list[i]);
              }
            } else {
              this.getCategoryList();
              this.getSupplierList();
              // this.selected_items = [];
            }
            this.$validator.reset();
            this.errors.clear();
          }
        })
        .catch(e => {});
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },

    getCategoryList() {
      this.$api
        .getAPI({ _action: "/category/list", _body: this.filterObj })
        .then(res => {
          this.categoryList = [];
          if (res.list != null && res.list.length > 0) {
            for (var i = 0; i < res.list.length; i++) {
              this.category = {};
              this.category.id = res.list[i].id;
              this.category.name = res.list[i].name;
              this.category.flag = false;
              this.categoryList.push(this.category);
            }
          }
        })
        .catch(e => {});
    },

    getSupplierList() {

      this.$api
        .getAPI({ _action: "/supplier/list", _body: this.filterObj })
        .then(res => {
          this.supplierList = [];
          if (res.list != null && res.list.length > 0) {
            for (var i = 0; i < res.list.length; i++) {
              this.supplier = {};
              this.supplier.id = res.list[i].id;
              this.supplier.name = res.list[i].name;
              this.supplier.flag = false;
              this.supplierList.push(this.supplier);
            }
          }
        })
        .catch(e => {});
    },

    removeSelectedItem(index) {
      this.selected_items.splice(index, 1);
    },
    validateForm(status) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save(status);
          return;
        }
      });
    },
    save(status) {
      this.order.items = this.selected_items;
      this.$api
        .postAPI({
          _action: "/inventory_count/",
          _body: this.order,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          if (status == "COUNT") {
            router.push("/count-stock/" + res.id);
          } else {
            router.push("/inventory-count");
          }
        })
        .catch(e => {
          console.log(e.message);
        });
    },
    async details(id) {
      this.order = {};
      this.selected_items = [];

      await this.$api
        .getAPI({
          _action: "/inventory_count/detail/" + id
        })
        .then(res => {
          this.order = res;

          if (this.order.note) {
            this.note_count = this.order.note.length;
          }
          this.selected_items = res.items
          this.filterObj.store_id = this.order.store_id;
        });
    },
    changeNoteCount() {
      if (this.note_count >= 300) {
        this.order.note = this.order.note.substring(0, 300);
        this.note_count = 300;
      }
      this.note_count = this.order.note.length;
    },
    getItemsByCategory() {
      this.filterObj.supplier_id = ''
      this.selected_items = [];
      for (var i = 0; i < this.categoryList.length; i++) {
        if (this.categoryList[i].flag) {
          this.filterObj.category_id = this.categoryList[i].id;
          this.getItemList(true, false);
        }
      }
      document.getElementById("category-cancel-btn").click();

      for (var i = 0; i < this.supplierList.length; i++) {
        this.supplierList[i].flag = false;
      }
    },

    getItemsBySupplier() {
      this.filterObj.category_id = '';
      this.selected_items = [];
      for (var i = 0; i < this.supplierList.length; i++) {
        if (this.supplierList[i].flag) {
          this.filterObj.supplier_id = this.supplierList[i].id;
          this.getItemList(true, false);
        }
      }
      document.getElementById("supplier-cancel-btn").click();
      for (var i = 0; i < this.categoryList.length; i++) {
        this.categoryList[i].flag = false;
      }
    },
    clearModal() {
      this.selected_items = [];
    }
  },
  async mounted() {
    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function() {
        $(".app-search").toggle(200);
        $(".app-search input").focus();
      }
    );
    this.getStoreList();
    this.getItemList(false, true);
    this.getCategoryList();
    this.getSupplierList();
    if (this.$route.params.id) {
      await this.details(this.$route.params.id);
    }

  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-9">
            <div class="card rounded-5 p-lg-3 border">
              <div class="card-body form-style">
                <div class="row mb-4">
                  <div class="col-lg-6">
                    <label for>{{$lang.messages.store}}</label>
                    <span style="color:#ff0000">*</span>
                    <div class="text-right custom-select-dd">
                      <select
                        v-model="filterObj.store_id"
                        class="form-control"
                        :class="{ 'is-danger': errors.has('store_id') }"
                        @change="getItemList(false, true)"
                        v-validate="'required'"
                        name="store_id"
                      >
                        <option value>{{$lang.messages.select_store}}</option>
                        <option v-for="obj in storeList" :key="obj.id" :value="obj.id">{{obj.name}}</option>
                      </select>
                      <i v-show="errors.has('store_id')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('store_id')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_store}}</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 mb-4">
                    <label for>{{$lang.messages.notes}}</label>
                    <label class="float-right">{{note_count}} / 300</label>
                    <textarea
                      class="form-control"
                      rows="1"
                      :placeholder="$lang.messages.write_here_something"
                      style="height: auto"
                      v-model="order.note"
                      maxlength="300"
                      v-on:keyup="changeNoteCount()"
                    ></textarea>
                  </div>
                  <div class="col-lg-12">
                    <label class="text-dark mr-3">{{$lang.messages.type}}</label>
                    <div class="custom-control custom-radio d-inline-block mr-5">
                      <input
                        type="radio"
                        class="custom-control-input"
                        id="customControlValidation3"
                        name="radio-stacked"
                        value="PARTIAL"
                        required
                        v-model="order.inventory_count_type"
                      />
                      <label
                        class="custom-control-label"
                        for="customControlValidation3"
                      >{{$lang.messages.partial}}</label>
                    </div>
                    <div class="custom-control custom-radio d-inline-block">
                      <input
                        type="radio"
                        class="custom-control-input"
                        id="customControlValidation2"
                        name="radio-stacked"
                        value="FULL"
                        required
                        v-model="order.inventory_count_type"
                      />
                      <label
                        class="custom-control-label"
                        for="customControlValidation2"
                      >{{$lang.messages.full}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-9">
            <div class="card mb-0 rounded-5 border">
              <div class="card-header px-4 mt-1 py-3 bg-white border-bottom">
                <div class="row" v-if="order.inventory_count_type == 'PARTIAL'">
                  <div class="col-md-5">
                    <h3 class="font-22 d-inline-block">{{$lang.messages.items}}</h3>
                  </div>

                  <div class="col-md-7 text-md-right">
                    <a
                      href
                      class="text-primary font-18 mr-4"
                      data-toggle="modal"
                      data-target="#addByCatge"
                    >{{$lang.messages.add_by_category}}</a>
                    <a
                      href
                      class="text-primary font-18"
                      data-toggle="modal"
                      data-target="#addBySupplier"
                    >{{$lang.messages.add_by_supplier}}</a>
                  </div>
                </div>
                <div v-else>
                  <h3 class="font-22 d-inline-block">{{$lang.messages.items}}</h3>

                  <div v-if="order.inventory_count_type == 'FULL'" style="padding: 20px;">
                    <h4>{{$lang.messages.all_items_will_be_counted}}</h4>
                  </div>
                </div>
              </div>
              <div class="card-body form-style px-4" v-if="order.inventory_count_type == 'PARTIAL'">
                <div class="table-responsive">
                  <table class="table table-style-1">
                    <thead>
                      <tr>
                        <th scope="col" width="350">{{$lang.messages.item}}</th>
                        <th scope="col" width="150">{{$lang.messages.expected_stock}}</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sel, index)  in selected_items" :key="'composite_item_'+index">
                        <td class="align-middle">
                          <span class="f-semi-bold">{{sel.name}}</span>
                          <br />
                          <span v-if="sel.sku">{{$lang.messages.sku}} {{sel.sku}}</span>
                        </td>
                        <td class="align-middle">{{sel.expected_stock ? sel.expected_stock : 0}}</td>
                        <td class="align-middle">
                          <a href="javascript:void(0)" @click="removeSelectedItem(index)">
                            <i class="far fa-trash-alt font-20 text-danger"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div>
                      <label class="typo__label">{{$lang.messages.item_search}}</label>
                      <span style="color:#ff0000">*</span>

                      <multiselect
                        v-validate="'required'"
                        v-model="selected_items"
                        :options="itemList"
                        :multiple="true"
                        :class="{'input': true, 'is-danger': errors.has('searchItem') }"
                        :close-on-select="true"
                        :clear-on-select="false"
                        v-bind:placeholder="$lang.messages.please_select_option"
                        label="name"
                        track-by="name"
                        name="searchItem"
                        :select-label="$lang.messages.please_enter_to_select"
                        :deselect-label="$lang.messages.please_enter_to_remove"
                        :selected-label="$lang.messages.selected"
                      >
                        <span slot="noOptions">{{$lang.messages.list_is_empty}}</span>
                        <template slot="selection">
                          <span class="multiselect__single" v-if="selected_items.length"></span>
                        </template>
                      </multiselect>

                      <i v-show="errors.has('searchItem')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('searchItem')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_atleast_one_item}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-9 text-right">
            <button
              type="button"
              class="btn btn-primary mr-3 mt-3"
              id="save-btn"
              @click="validateForm()"
            >{{$lang.messages.save_btn_text}}</button>
            <button
              type="button"
              class="btn btn-primary mr-3 mt-3"
              id="count-btn"
              @click="validateForm('COUNT')"
            >{{$lang.messages.save_and_count}}</button>

            <button
              type="button"
              class="btn btn-outline-primary mt-lg-0 mt-3"
              id="cancel-btn"
              @click="$router.go(-1)"
            >{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Box -->
    <div
      class="modal fade"
      id="addByCatge"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addByCatgeTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content py-lg-4">
          <div class="modal-header border-0 px-lg-5 px-4">
            <h5 class="modal-title font-22">
              <p>{{$lang.messages.add_items_by_category}}</p>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body px-lg-5 px-4 form-style">
            <div class="row mb-4">
              <div class="col-lg-12 mb-5">
                <label>{{$lang.messages.category_search}}</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control border-right-0"
                    :placeholder="$lang.messages.type_to_search_here"
                    v-model="filterObj.search"
                    @keyup="getCategoryList()"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text bg-white border-secondary">
                      <i class="fas fa-search font-16"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center" v-if="categoryList.length <= 0">
                <p>{{$lang.messages.You_have_no_items_assigned_to_any_category_yet}}</p>
              </div>
              <div class="col-12" v-else>
                <div v-for="(obj, index) in categoryList" :key="obj.id">
                  <div class="col-md-6 text-left align-self-center">
                    <div class="form-group">
                      <span class="switch switch-sm">
                        <input
                          type="checkbox"
                          class="switch"
                          :id="'switch_'+index"
                          :name="'switch_'+index"
                          v-model="obj.flag"
                        />
                        <label :for="'switch_'+index">{{obj.name}}</label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center pt-lg-5 pt-4">
            <button
              type="button"
              class="btn btn-primary mr-3"
              @click="getItemsByCategory()"
            >{{$lang.messages.add}}</button>
            <button
              type="button"
              class="btn btn-outline-primary"
              data-dismiss="modal"
              aria-label="Close"
              id="category-cancel-btn"
            >{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="addBySupplier"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addBySupplier"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content py-lg-4">
          <div class="modal-header border-0 px-lg-5 px-4">
            <h5 class="modal-title font-22">{{$lang.messages.add_items_by_supplier}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body px-lg-5 px-4 form-style">
            <div class="row mb-4">
              <div class="col-lg-12 mb-5">
                <label>{{$lang.messages.supplier_search}}</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control border-right-0"
                    :placeholder="$lang.messages.type_to_search_here"
                    v-model="filterObj.search"
                    @keyup="getSupplierList()"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text bg-white border-secondary">
                      <i class="fas fa-search font-16"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center" v-if="supplierList.length <= 0">
                <p>{{$lang.messages.You_have_no_items_assigned_to_any_supplier_yet}}</p>
              </div>
              <div class="col-12" v-else>
                <div v-for="(obj, index) in supplierList" :key="obj.id">
                  <div class="col-md-6 text-left align-self-center">
                    <div class="form-group">
                      <span class="switch switch-sm">
                        <input
                          type="checkbox"
                          class="switch"
                          :id="'switch1_'+index"
                          :name="'switch1_'+index"
                          v-model="obj.flag"
                        />
                        <label :for="'switch1_'+index">{{obj.name}}</label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center pt-lg-5 pt-4">
            <button
              type="button"
              class="btn btn-primary mr-3"
              @click="getItemsBySupplier()"
            >{{$lang.messages.add}}</button>
            <button
              type="button"
              class="btn btn-outline-primary"
              data-dismiss="modal"
              aria-label="Close"
              id="supplier-cancel-btn"
            >{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
